export enum StorageKeys {
  AccessToken = 'token',
  TokenData = 'TokenData',
  UserData = 'UserData',
  CurrentLanguage = 'currentLang'
}
